import { MutualFundsFundsHoldingsComparablesModule } from './app.module';
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
bootstrapAppModule(MutualFundsFundsHoldingsComparablesModule);
